import axios from "axios";
// import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetVrList = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VR_LIST_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/home-vr/list`, listData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VR_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VR_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "VR_LIST_FAIL", payload: error?.response });
    }
  };
};

export const AddVrItem = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VR_ADD_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/home-vr/add`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VR_ADD_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "VR_ADD_FAIL", payload: data.message || "Add failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "VR_ADD_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const UpdateVrItem = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VR_UPDATE_REQUEST" });
      const { data } = await axios.post(`${BASE_URL}/home-vr/update`, payload, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VR_UPDATE_SUCCESS", payload: data });
        return Promise.resolve(data);
      } else {
        dispatch({ type: "VR_UPDATE_FAIL", payload: data.message || "Update failed" });
        return Promise.reject(new Error(data.message));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Network error";
      dispatch({ type: "VR_UPDATE_FAIL", payload: errorMessage });
      return Promise.reject(new Error(errorMessage));
    }
  };
};

export const ViewVrItem = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VR_VIEW_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/home-vr/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VR_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VR_VIEW_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "VR_VIEW_FAIL", payload: error?.response?.data?.message });
    }
  };
};

export const GetVrThreeSixtyProjects = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VR_THREE_SIXTY_PROJECTS_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/home-vr/three-sixty-projects`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VR_THREE_SIXTY_PROJECTS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VR_THREE_SIXTY_PROJECTS_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "VR_THREE_SIXTY_PROJECTS_FAIL", payload: error?.response });
    }
  };
};